import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for dynamic meta tags
import Propertylist from '../../Components/PropertyList/Propertylist.jsx';
import Head from '../../Components/PropertyList/Head.jsx';

const Properties = () => {
  return (
    <>
      <Helmet>
        <title>Find the Best Real Estate Properties for Investment 
</title>
        <meta
          name="description"
          content="CoOwnSpace Fractional ownership: The future of real estate. Invest smarter, own effortlessly! Explore real estate properties for sale with high ROI potential. Invest in residential, commercial, and luxury properties for long-term growth."
        />
        <meta name="keywords" content="real estate, properties for investment, fractional ownership, high ROI, residential, commercial, luxury properties" />
        <meta property="og:title" content="CoOwnSpace - Future of Real Estate | Find the Best Real Estate Properties for Investment" />
        <meta
          property="og:description"
          content="CoOwnSpace Fractional ownership: The future of real estate. Invest smarter, own effortlessly! Explore real estate properties for sale with high ROI potential. Invest in residential, commercial, and luxury properties for long-term growth."
        />
        <meta property="og:image" content="URL_to_image" /> 
        <meta property="og:url" content="https://www.coownspace.com/properties" />
      </Helmet>
      <Head />
      <Propertylist />
    </>
  );
};

export default Properties;
